(function () {

 'use strict';

  angular.module('eclipseApp.core').filter('prepaidRefillAmount', ['$filter', '$rootScope', 'uteLocale', function ($filter, $rootScope, uteLocale) {
    var $translate = $filter('translate');
    return function (obj) {
      // N.B. It's better to format the currency in the JS file than to do it through the JSON keys (by adding empty strings as values).
      //      If there are any problems with the following ternary, please ask Ramesh to contact Ed.
      return (uteLocale.language === 'en') ? '$' + obj.rechargeAmount + ' ' + $translate('global.label.for') + ' ' + obj.duration + ' ' + $translate('global.label.days') : obj.rechargeAmount + ' $ ' + $translate('global.label.for') + ' ' + obj.duration + ' ' + $translate('global.label.days');

      // TODO: Delete old code if ternary works.
      // return $translate('wireless.label.refill$En')+obj.rechargeAmount+$translate('wireless.label.refillForWithSpace')+obj.duration+$translate('wireless.label.refillDaysWithSpace')+$translate('wireless.label.refill$Fr');
    };
  }]);
})();
